module.exports = __webpack_public_path__ + "media/images/v2/meeting_white-b9ee7e8090d67d0cba1b1748f30befa1.png";